import React, { useContext, useState } from "react";
import { Modal } from "react-bootstrap";
import { Button } from "@mui/material";
import GroupPermission from "./GroupPermission";
import { UserGroupsModalProps, IPermission } from "./GroupPermissionInterfaces";
import LoadingButton from "@mui/lab/LoadingButton";
import blogFetch from "../../axios/config";
import language from "../../nls/language.json";
import Context from "../../context/Context";

const GroupPermissionModal: React.FC<UserGroupsModalProps> = ({
  open,
  onClose,
  group,
}) => {
  const [permissions, setPermissions] = useState<IPermission[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const {
    selectedCountry
  } = useContext(Context);

  const updateGroupsPermission = async () => {
    try {
      setLoading(true);
      const newListUserGroups = [];

      for (const permission of permissions) {
        if (permission.checked) {
          const newUserGroup = {
            GroupPermissions_GroupId: group?.group_Id,
            GroupPermissions_PermissionId: permission.permissions_Id,
            GroupPermissions_companyId: group?.group_CompanyId,
          };
          newListUserGroups.push(newUserGroup);
        }
      }

      const response = await blogFetch.post(
        `/GroupPermissions/lote_`,
        newListUserGroups
      );
      const data = response.data;
      setTimeout(() => {
        setLoading(false);
      }, 500);
      return data;
    } catch (error) {
      console.error(error);
      setTimeout(() => {
        setLoading(false);
      }, 500);
      throw error;
    }
  };

  return (
    <Modal show={open} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {group && `${(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.editar.title} ${group.group_description.toUpperCase()}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body >
        <div className="flex flex-wrap w-full p-2 mx-auto justify-center items-center truncate overflow-auto gap-2 box-border">
          {group && (
            <GroupPermission
              onClose={onClose}
              group={group}
              setPermissions={setPermissions}
              permissions={permissions}
            />
          )}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: "flex", gap: 10 }}>
      <Button variant="text" onClick={onClose}>
        {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarPermissao.btnCancelar}
        </Button>
        {loading ? (
          <LoadingButton loading variant="outlined">
            Submit
          </LoadingButton>
        ) : (
          <Button variant="contained" onClick={updateGroupsPermission}>
            {(language as Record<string, any>)[selectedCountry.name].Permissoes.grupos.modal.adicionarPermissao.btnSalvar}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default GroupPermissionModal;
